import { Component, OnInit } from '@angular/core';
import { SidebarComponent } from 'web-common/src/app/sidebar/sidebar.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admin-sidebar',
  templateUrl: './admin-sidebar.component.html',
  styleUrls: ['../../../node_modules/web-common/src/app/sidebar/sidebar.component.less', '../../styles/admin-sidebar.component.less'],

})
export class AdminSidebarComponent extends SidebarComponent implements OnInit {
  showSubmenu = false;

  constructor(
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.currentRouteSubscribe();
  }

  private currentRouteSubscribe() {
    this.route.url.subscribe(url => {
      switch (url.join('/')) {
        case 'analytics/usage':
        case 'analytics/references-added':
        case 'analytics/accounts-created':
        case 'analytics/publications-added':
        case 'analytics/publications-cited':
        case 'analytics/publications-viewed':
        case 'analytics/publications-read':
        case 'analytics/library-views':
          this.showSubmenu = true;
          break;
        default:
          this.showSubmenu = false;
      }
    });
  };

}
